import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Text, Button, colors } from 'react-orange-ui';
import styled from 'styled-components';

import InputCheckbox from '../../../orange-ui/components/Input/InputCheckbox';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';
import Spinner from '../../Spinner/Spinner';

const Container = styled.div`
  margin: 1rem 0;
`;

const Helper = styled.div`
  display: ${props => props.message ? 'block' : 'none'};
  width: 100%;
  background-color: ${colors.grey6};
  padding: 1rem;
  margin-bottom: 1rem;
`;

class AddContactView extends Component {
  state = {
    valueMobile: '',
    valueMail: '',
    checkNoMobile: false,
    checkNoMail: false,
    messageHelp: null,
    isFetching: true,
    buttonLabel: WordingService.getWording('button', 'add'),
  };

  async componentDidMount() {
    const { fetchInputsAndDeclaredContacts } = this.props;

    await fetchInputsAndDeclaredContacts();

    // Set the declared contacts
    this.setDeclaredContacts();

    // Finish fetching data
    this.setState({
      isFetching: false,
    });
  }

  /**
   * Update message help and button label on checkbox update
   * @param prevProps
   * @param prevState
   */
  componentDidUpdate(prevProps, prevState) {
    const { checkNoMail, checkNoMobile } = this.state;

    if ((prevState.checkNoMail !== checkNoMail) || (prevState.checkNoMobile !== checkNoMobile)) {
      this.updateHelpMessage();
      this.updateButtonLabel();
    }
  }

  /**
   * Function to update help message wording
   */
  updateHelpMessage = () => {
    const { checkNoMobile, checkNoMail } = this.state;

    if (checkNoMobile && checkNoMail) {
      this.setState({
        messageHelp: WordingService.getWording('hint', 'noContactAdvice'),
      });
    } else if (checkNoMobile || checkNoMail) {
      this.setState({
        messageHelp: WordingService.getWording('hint', 'addContactAdvice'),
      });
    } else {
      this.setState({
        messageHelp: null,
      });
    }
  };

  /**
   * Function to set the declared contacts
   */
  setDeclaredContacts = () => {
    const { declared } = this.props;

    if (declared.mobile || declared.mail) {
      this.setState({
        valueMail: declared.mail,
        valueMobile: declared.mobile,
      });
    }
  };

  /**
   * Function to valid form
   * @return {boolean}
   */
  validateForm = () => {
    const { showMobile, showMail, errors } = this.props;
    const {
      checkNoMobile, checkNoMail, valueMobile, valueMail,
    } = this.state;

    let isValid = true;

    if (showMail && (!checkNoMail && (!valueMail || !errors.mail.valid))) {
      isValid = false;
    }
    if (showMobile && (!checkNoMobile && (!valueMobile || !errors.mobile.valid))) {
      isValid = false;
    }
    return isValid;
  };

  /**
   * Function to update button label
   * @return {*}
   */
  updateButtonLabel = () => {
    const { checkNoMail, checkNoMobile } = this.state;
    const { showMobile, showMail } = this.props;

    if (showMail && showMobile && (checkNoMobile && checkNoMail)) {
      this.setState({ buttonLabel: WordingService.getWording('button', 'continue') });
    } else if (showMobile && !showMail && checkNoMobile) {
      this.setState({ buttonLabel: WordingService.getWording('button', 'continue') });
    } else if (showMail && !showMobile && checkNoMail) {
      this.setState({ buttonLabel: WordingService.getWording('button', 'continue') });
    } else {
      this.setState({ buttonLabel: WordingService.getWording('button', 'add') });
    }
  };

  /**
   * Set value state on change, clear errors when exists
   * @param field
   * @param value
   */
  handleChange = (field, value) => {
    const { clearInputError, errors } = this.props;

    if (!errors[field].valid) {
      clearInputError({ field });
    }
    switch (field) {
      case 'mobile':
        this.setState({ valueMobile: value.trim() });
        break;
      case 'mail':
        this.setState({ valueMail: value.trim() });
        break;
      default:
        break;
    }
  };

  handleBlur = (field) => {
    const { valueMail, valueMobile } = this.state;
    const { checkCredentials, setInputError } = this.props;

    switch (field) {
      case 'mobile':
        if (!valueMobile) {
          setInputError({ field, error: 'empty' });
        } else {
          checkCredentials(field, valueMobile);
        }
        break;
      case 'mail':
        if (!valueMail) {
          setInputError({ field, error: 'empty' });
        } else {
          checkCredentials(field, valueMail);
        }
        break;
      default:
        break;
    }
  };

  handleCheck = (field, check) => {
    const { errors, clearInputError } = this.props;

    if (!errors[field].valid) {
      clearInputError({ field });
    }
    switch (field) {
      case 'mobile':
        this.setState(prevState => ({
          valueMobile: check ? '' : prevState.valueMobile,
          checkNoMobile: check,
        }));
        break;
      case 'mail':
        this.setState(prevState => ({
          valueMail: check ? '' : prevState.valueMail,
          checkNoMail: check,
        }));
        break;
      default:
        break;
    }
  };

  handleClick = (e) => {
    e.preventDefault();

    const { updateContacts } = this.props;
    const {
      valueMobile, valueMail, checkNoMobile, checkNoMail,
    } = this.state;
    let checked;
    if (checkNoMobile && checkNoMail) {
      checked = 'both';
      TagService.sendAction('checkedBoth');
    } else if (checkNoMobile) {
      checked = 'mobile';
      TagService.sendAction('checkedNoMobile');
    } else if (checkNoMail) {
      checked = 'email';
      TagService.sendAction('checkedNoMail');
    }

    updateContacts({
      mobile: valueMobile || undefined,
      mail: valueMail || undefined,
      checked,
    });
  };

  render() {
    const {
      errors, showMobile, showMail, isLoading,
    } = this.props;
    const {
      valueMobile, valueMail, messageHelp, isFetching, buttonLabel,
    } = this.state;

    if (isFetching) {
      return <Spinner />;
    }
    return (
      <div>
        <Row>
          <Col xs={12} sm={12} md={9} lg={6} xl={6}>
            <Text id="add-contact-message">
              {WordingService.getWording('caption', 'addNewContacts')}
            </Text>
            <Container>
              {showMobile && (
              <InputCheckbox
                id="add-mobile"
                radioLabel={WordingService.getWording('caption', 'haveNoMobile')}
                label={WordingService.getWording('caption', 'addMobile')}
                onChange={event => this.handleChange('mobile', event)}
                onCheck={check => this.handleCheck('mobile', check)}
                onBlur={() => this.handleBlur('mobile')}
                maxLength={15}
                errorMessage={errors.mobile.errorMessage}
                valid={errors.mobile.valid}
                value={valueMobile}
              />
              )}
              {showMail && (
                <>
                  <br />
                  <InputCheckbox
                    id="add-mail"
                    radioLabel={WordingService.getWording('caption', 'haveNoMail')}
                    label={WordingService.getWording('caption', 'addMail')}
                    onChange={event => this.handleChange('mail', event)}
                    onCheck={check => this.handleCheck('mail', check)}
                    onBlur={() => this.handleBlur('mail')}
                    errorMessage={errors.mail.errorMessage}
                    valid={errors.mail.valid}
                    value={valueMail}
                  />
                </>
              )}
            </Container>
            { messageHelp
            && (
            <Helper id="no-contact-warning" message={messageHelp}>
              <Text>
                {messageHelp}
              </Text>
            </Helper>
            )
            }
            <Button id="submit-contacts" type="fill" disabled={isLoading || !this.validateForm()} onClick={this.handleClick} onMouseDown={this.handleClick}>
              {buttonLabel}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

AddContactView.defaultProps = {
  isLoading: false,
  showMobile: true,
  showMail: true,
  errors: {
    mobile: {
      valid: true,
      errorMessage: '',
    },
    mail: {
      valid: true,
      errorMessage: '',
    },
  },
  declared: {
    mail: '',
    mobile: '',
  },
};

AddContactView.propTypes = {
  /** Function to get user contact data */
  fetchInputsAndDeclaredContacts: PropTypes.func.isRequired,
  /** Function to add new contacts */
  updateContacts: PropTypes.func.isRequired,
  /** Function to set an input error */
  setInputError: PropTypes.func.isRequired,
  /** Function to clear an input error */
  clearInputError: PropTypes.func.isRequired,
  /** Function to check input credentials */
  checkCredentials: PropTypes.func.isRequired,
  /** Boolean indicate when a request is pending */
  isLoading: PropTypes.bool,
  /** Boolean show mail input */
  showMail: PropTypes.bool,
  /** Boolean show mobile input */
  showMobile: PropTypes.bool,
  /** Object errors */
  errors: PropTypes.shape(),
  /** Object of declared contacts when exists */
  declared: PropTypes.shape({
    mail: PropTypes.string,
    mobile: PropTypes.string,
  }),
};

export default AddContactView;
